import React, { useEffect, useState } from "react";
import { PieChart, Moon } from "lucide-react";
import { api } from "../lib/api";

const usd = (v) => `$${Math.round(v || 0).toLocaleString()}`;
const NAMES = { safety: "Safety", slow: "Slow money", options: "Options income", fast: "Fast money" };
const BAR = { safety: "bg-sky-400", slow: "bg-emerald-400", options: "bg-violet-400", fast: "bg-amber-400" };

const Row = ({ k, b }) => {
  const pct = b.cap ? Math.min(100, (b.used / b.cap) * 100) : 0;
  return (
    <div className="space-y-1" data-testid={`bucket-${k}`}>
      <div className="flex items-baseline gap-2 text-xs">
        <span className="text-cyan-50 font-semibold">{NAMES[k]}</span>
        <span className="text-cyan-200/40 nx-mono">{b.pct}%</span>
        <span className="ml-auto nx-mono text-cyan-100" data-testid={`bucket-${k}-used`}>
          {k === "safety" ? `${usd(b.cap)} cash` : `${usd(b.used)} / ${usd(b.cap)}`}
        </span>
      </div>
      <div className="h-2 rounded-full bg-white/5 overflow-hidden">
        <div className={`h-full ${pct >= 100 ? "bg-rose-500" : BAR[k]} transition-[width] duration-500`} style={{ width: `${k === "safety" ? 100 : pct}%` }} />
      </div>
    </div>
  );
};

export const BucketsCard = () => {
  const [d, setD] = useState(null);
  useEffect(() => {
    const load = () => api.get("/house/buckets").then((r) => setD(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);
  const b = d?.buckets, f = b?.fast;
  return (
    <div className="bg-[#060b18] border border-[#00F0FF22] rounded-2xl p-4 space-y-3" data-testid="buckets-card">
      <div className="flex items-center gap-2">
        <PieChart className="w-4 h-4 text-[#00F0FF]" />
        <p className="text-xs nx-mono tracking-widest text-cyan-300/70">Four Buckets</p>
        <span className="text-[10px] text-cyan-200/40">equity {usd(d?.equity)} · options {d?.options_live ? "LIVE" : "paper"}</span>
      </div>
      {b ? ["safety", "slow", "options", "fast"].map((k) => <Row key={k} k={k} b={b[k]} />) : <p className="text-xs text-cyan-200/40">loading…</p>}
      {f && (
        <div className={`flex items-center gap-2 text-xs rounded-lg px-3 py-2 ${f.asleep ? "bg-rose-500/10 text-rose-300" : "bg-white/5 text-cyan-200/70"}`} data-testid="bucket-fast-status">
          <Moon className="w-3.5 h-3.5" />
          {f.asleep ? `Fast money ASLEEP until ${f.asleep_until} (MTD ${f.mtd_pct}%)` : `Fast money awake · ${f.entries_today}/${f.max_per_day} entries today · MTD ${usd(f.mtd_pnl)} (${f.mtd_pct}%)`}
        </div>
      )}
    </div>
  );
};
